import { render } from "./TestInstructionsStepThree.vue?vue&type=template&id=b4e15138&scoped=true&ts=true"
import script from "./TestInstructionsStepThree.vue?vue&type=script&lang=ts"
export * from "./TestInstructionsStepThree.vue?vue&type=script&lang=ts"

import "./TestInstructionsStepThree.vue?vue&type=style&index=0&id=b4e15138&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4e15138"]])

export default __exports__